import React from "react";

const Div = ({ st, children }: { st?: React.CSSProperties; children: React.ReactNode }) => {
  const defaultStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "10px",
    lineHeight: 0,
  };
  return <div style={{ ...defaultStyle, ...st }}>{children}</div>;
};

export const ChevronLeft = ({ st }: { st?: React.CSSProperties }) => {
  return (
    <Div st={{ color: "#fff", ...st }}>
      <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.5 15L12.5 10L7.5 5"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Div>
  );
};

export const Info = ({ st }: { st?: React.CSSProperties }) => {
  return (
    <Div st={st}>
      <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.99995 13.9205C11.1909 13.9205 13.7777 11.3337 13.7777 8.14277C13.7777 4.95179 11.1909 2.36499 7.99995 2.36499C4.80897 2.36499 2.22217 4.95179 2.22217 8.14277C2.22217 11.3337 4.80897 13.9205 7.99995 13.9205Z"
          stroke="#000038"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M8 10.8095V8.14282" stroke="#000038" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 5.47607H8.0075" stroke="#000038" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </Div>
  );
};

export const Logo = ({ st }: { st?: React.CSSProperties }) => {
  return (
    <Div st={{ color: "#000038", ...st }}>
      <svg width="6.75em" height="1em" viewBox="0 0 108 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask
          id="mask0_162_432"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="1"
          y="1"
          width="106"
          height="15">
          <path d="M106.688 1.00732H1.11328V15.5209H106.688V1.00732Z" fill="white" />
        </mask>
        <g mask="url(#mask0_162_432)">
          <path
            d="M8.68969 6.78881L4.20595 15.6774H1.20972L8.68969 0.849121L16.1697 15.6774H13.1735L8.68969 6.78881Z"
            fill="currentColor"
          />
          <path
            d="M28.8853 13.0336V15.6774H21.6626C20.9146 15.6774 20.2091 15.508 19.5685 15.1903C18.6282 14.7257 17.859 13.9644 17.4107 13.0336C17.0898 12.3996 16.9187 11.7012 16.9187 10.9609V0.870117H19.5897V11.2142C19.7184 12.1449 20.4664 12.8853 21.4067 13.0126L28.8867 13.0336H28.8853Z"
            fill="currentColor"
          />
          <path
            d="M32.3037 8.27377C32.3037 10.8965 34.4615 13.0322 37.1113 13.0322H43.0953V15.676H37.1113C32.9867 15.676 29.6313 12.3549 29.6313 8.27232C29.6313 4.18985 32.9867 0.870117 37.1113 0.870117H43.0953V3.51387H37.1113C34.4615 3.51387 32.3037 5.64959 32.3037 8.27232V8.27377Z"
            fill="currentColor"
          />
          <path
            d="M58.8019 0.870117V15.6774H56.1309V8.88816H48.0103V15.6774H45.3394V0.870117H48.0103V6.243H56.1309V0.870117H58.8019Z"
            fill="currentColor"
          />
          <path
            d="M63.6997 4.85324V6.2304H74.5095V8.87835H63.6997V11.6746C63.6997 12.4206 64.3162 13.0308 65.0699 13.0308H74.5095V15.6788H65.0699C62.8569 15.6788 61.0469 13.8874 61.0469 11.697V4.85184C61.0457 2.65034 62.8669 0.849121 65.091 0.849121H74.5095V3.49707H65.0699C64.3162 3.49707 63.6997 4.10728 63.6997 4.85324Z"
            fill="currentColor"
          />
          <path
            d="M90.1356 4.86304C90.1356 2.64615 88.3203 0.849121 86.0803 0.849121H76.7522V15.6774H79.4279V8.87835H82.8609C83.3829 8.87835 83.8521 9.16525 84.0856 9.62713L85.8047 13.0294L87.1426 15.6774H90.1344L86.6757 8.83359C88.6329 8.54808 90.1344 6.87978 90.1344 4.86304H90.1356ZM86.0803 6.229H79.4279V3.49707H86.0803C86.8411 3.49707 87.4604 4.11008 87.4604 4.86304C87.4604 5.616 86.8411 6.229 86.0803 6.229Z"
            fill="currentColor"
          />
          <path
            d="M99.1116 6.78881L94.6276 15.6774H91.6316L99.1116 0.849121L106.592 15.6774H103.596L99.1116 6.78881Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </Div>
  );
};

export const Smile = ({ st }: { st?: React.CSSProperties }) => {
  return (
    <Div st={st}>
      <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.99992 15.1668C11.6818 15.1668 14.6666 12.1821 14.6666 8.50016C14.6666 4.81826 11.6818 1.8335 7.99992 1.8335C4.31802 1.8335 1.33325 4.81826 1.33325 8.50016C1.33325 12.1821 4.31802 15.1668 7.99992 15.1668Z"
          stroke="#000038"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.33325 9.8335C5.33325 9.8335 6.33325 11.1668 7.99992 11.1668C9.66659 11.1668 10.6666 9.8335 10.6666 9.8335"
          stroke="#000038"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M6 6.5H6.0075" stroke="#000038" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 6.5H10.0075" stroke="#000038" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </Div>
  );
};

export const ThumbsUp = ({ st }: { st?: React.CSSProperties }) => {
  return (
    <Div st={st}>
      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_162_466)">
          <path
            d="M4.66659 7.3335L7.33325 1.3335C7.86369 1.3335 8.37239 1.54421 8.74747 1.91928C9.12254 2.29436 9.33325 2.80306 9.33325 3.3335V6.00016H13.1066C13.2999 5.99797 13.4913 6.03783 13.6676 6.11697C13.844 6.19612 14.001 6.31265 14.1278 6.45851C14.2547 6.60436 14.3483 6.77604 14.4021 6.96166C14.456 7.14728 14.4689 7.3424 14.4399 7.5335L13.5199 13.5335C13.4717 13.8514 13.3102 14.1412 13.0652 14.3495C12.8202 14.5578 12.5081 14.6705 12.1866 14.6668H4.66659M4.66659 7.3335V14.6668M4.66659 7.3335H2.66659C2.31296 7.3335 1.97382 7.47397 1.72378 7.72402C1.47373 7.97407 1.33325 8.31321 1.33325 8.66683V13.3335C1.33325 13.6871 1.47373 14.0263 1.72378 14.2763C1.97382 14.5264 2.31296 14.6668 2.66659 14.6668H4.66659"
            stroke="#000038"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_162_466">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Div>
  );
};

export const Vector = ({ st }: { st?: React.CSSProperties }) => {
  return (
    <Div st={st}>
      <svg width="0.75em" height="0.5em" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1.5L6 6.5L11 1.5" stroke="#DDDDDD" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </Div>
  );
};

export const Back = ({ st }: { st?: React.CSSProperties }) => {
  return (
    <Div st={{ color: "#000038", ...st }}>
      <svg width="2em" height="2em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.7615 6.66675L9.33338 16.0948L18.7615 25.5229"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Div>
  );
};

export const Close = ({ st }: { st?: React.CSSProperties }) => {
  return (
    <Div st={{ color: "#000038", ...st }}>
      <svg width="2em" height="2em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.29289 8.70711C6.90237 8.31658 6.90237 7.68342 7.29289 7.29289C7.68342 6.90237 8.31658 6.90237 8.70711 7.29289L16 14.5858L23.2929 7.29289C23.6834 6.90237 24.3166 6.90237 24.7071 7.29289C25.0976 7.68342 25.0976 8.31658 24.7071 8.70711L17.4142 16L24.7071 23.2929C25.0976 23.6834 25.0976 24.3166 24.7071 24.7071C24.3166 25.0976 23.6834 25.0976 23.2929 24.7071L16 17.4142L8.70711 24.7071C8.31658 25.0976 7.68342 25.0976 7.29289 24.7071C6.90237 24.3166 6.90237 23.6834 7.29289 23.2929L14.5858 16L7.29289 8.70711Z"
          fill="currentColor"
        />
      </svg>
    </Div>
  );
};

export const Frown = ({ st }: { st?: React.CSSProperties }) => {
  return (
    <Div st={{ color: "#000038", ...st }}>
      <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.00016 15.1668C11.6821 15.1668 14.6668 12.1821 14.6668 8.50016C14.6668 4.81826 11.6821 1.8335 8.00016 1.8335C4.31826 1.8335 1.3335 4.81826 1.3335 8.50016C1.3335 12.1821 4.31826 15.1668 8.00016 15.1668Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6668 11.1668C10.6668 11.1668 9.66683 9.8335 8.00016 9.8335C6.3335 9.8335 5.3335 11.1668 5.3335 11.1668"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M6 6.5H6.00833" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 6.5H10.0083" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </Div>
  );
};
